// extracted by mini-css-extract-plugin
export var active = "_ab-c";
export var activeIndicator = "_ab-7";
export var animate = "_ab-b";
export var contentWidthTabs = "_ab-5";
export var disabled = "_ab-d";
export var flat = "_ab-1";
export var fullWidth = "_ab-3";
export var lg = "_ab-a";
export var md = "_ab-9";
export var redoButtonTabGroup = "_ab-0";
export var sm = "_ab-8";
export var tabButton = "_ab-4";
export var tabButtonsContainer = "_ab-2";
export var xs = "_ab-6";